import React, { useEffect, useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Box,
    Typography,
    Grid,
    Card,
    Divider,
    CardContent,
    IconButton,
    Avatar,
    Chip,
    Button
} from "@mui/material";
import { RxCross2 } from "react-icons/rx";
import moment from "moment";
import StatusBadge from "components/badge/StatusBadge";

const ViewPBG = (props) => {
    const { open, handleClose, rowData } = props;

    const labelStyle = {
        fontSize: "14px",
        color: "#6b7280",
        display: "flex",
        alignItems: "center",
        gap: "4px",
    };

    const valueStyle = {
        fontSize: "15px",
        color: "#111827",
        fontWeight: 500,
        mt: 0.5,
    };

    const formatINR = (value) => {
        if (!value && value !== 0) return "N/A";
        return Number(value).toLocaleString("en-IN");
    };

    return (
        <>
            <Dialog
                open={open}
                fullWidth
                maxWidth="md"
                PaperProps={{
                    sx: {
                        borderTopLeftRadius: "5px",
                        borderTopRightRadius: "5px",
                        backgroundColor: "#FFFFFF",
                        width: "100%",
                        overflowX: "hidden"
                    },
                }}
                disableEscapeKeyDown
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleClose();
                    }
                }}
            >
                <DialogTitle sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    borderBottom: "1px solid #ddd",
                    backgroundColor: "#ECECEC",
                    pb: 2,
                    pt: 3,
                    width: "100%",
                }}>
                    <Typography sx={{
                        fontWeight: 600,
                        fontSize: "27px",
                        lineHeight: "100%",
                        color: "#140F36",
                        fontFamily: "Outfit, sans-serif"
                    }}>
                        View PBG Details
                    </Typography>
                    <IconButton
                        aria-label="close"
                        onClick={() => handleClose()}
                        sx={(theme) => ({
                            position: "absolute",
                            right: 8,
                            top: 8,
                            color: theme.palette.grey[500],
                        })}
                    >
                        <RxCross2 style={{ fontSize: "30px", color: "#140F36" }} />
                    </IconButton>
                </DialogTitle>

                <DialogContent dividers>
                    <Card
                        elevation={0}
                        sx={{
                            borderRadius: "3px",
                            border: "1px solid #e5e7eb",
                            backgroundColor: "#fff",
                            p: 2,
                        }}
                    >
                        {/* Header */}
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                mb: 1,
                            }}
                        >
                            <Typography sx={{ fontWeight: 600, fontSize: "16px" }}>
                                PBG Information
                            </Typography>
                        </Box>

                        <Divider sx={{ mb: 2 }} />

                        <CardContent sx={{ pt: 0 }}>
                            <Grid container spacing={2}>

                                <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                    <Typography sx={labelStyle}>Contract / Project Name:</Typography>
                                    <Typography sx={valueStyle}>{rowData?.contractProjectName ?? "N/A"}</Typography>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                    <Typography sx={labelStyle}>Beneficiary (Client / Owner):</Typography>
                                    <Typography sx={valueStyle}>{rowData?.beneficiary ? rowData?.beneficiary : "N/A"}</Typography>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                    <Typography sx={labelStyle}>Contract Value (₹ L):</Typography>
                                    <Typography sx={valueStyle}>{formatINR(rowData?.contractValue)}</Typography>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                    <Typography sx={labelStyle}>Issuing Bank:</Typography>
                                    <Typography sx={valueStyle}>{rowData?.issuingBank ? rowData?.issuingBank : "N/A"}</Typography>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                    <Typography sx={labelStyle}>Branch / IFSC:</Typography>
                                    <Typography sx={valueStyle}>{rowData?.branchOrIFSC ? rowData?.branchOrIFSC : "N/A"}</Typography>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                    <Typography sx={labelStyle}>BG Reference Number:</Typography>
                                    <Typography sx={valueStyle}>{rowData?.bgReferenceNumber ? rowData?.bgReferenceNumber : "N/A"}</Typography>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                    <Typography sx={labelStyle}>BG Amount (₹ L):</Typography>
                                    <Typography sx={valueStyle}>{formatINR(rowData?.bgAmount)}</Typography>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                    <Typography sx={labelStyle}>PBG % Of Contract:</Typography>
                                    <Typography sx={valueStyle}>{rowData?.pbgPercentageOfContract ? rowData?.pbgPercentageOfContract : "N/A"}</Typography>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                    <Typography sx={labelStyle}>Date Of Issue:</Typography>
                                    <Typography sx={valueStyle}>
                                        {rowData?.dateOfIssue ? moment.utc(rowData?.dateOfIssue).format("DD MMM YYYY") : "N/A"}
                                    </Typography>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                    <Typography sx={labelStyle}>Date Of Expiry:</Typography>
                                    <Typography sx={valueStyle}>
                                        {rowData?.dateOfExpiry ? moment.utc(rowData?.dateOfExpiry).format("DD MMM YYYY") : "N/A"}
                                    </Typography>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                    <Typography sx={labelStyle}>Status:</Typography>
                                    <Typography sx={valueStyle}>
                                        <StatusBadge status={rowData?.status} />
                                    </Typography>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                    <Typography sx={labelStyle}>Date Of Release:</Typography>
                                    <Typography sx={valueStyle}>
                                        {rowData?.dateOfRelease ? moment.utc(rowData?.dateOfRelease).format("DD MMM YYYY") : "N/A"}
                                    </Typography>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                    <Typography sx={labelStyle}>Days To Expiry:</Typography>
                                    <Typography sx={valueStyle}>{rowData?.daysToExpiry ? rowData?.daysToExpiry : "N/A"}</Typography>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                    <Typography sx={labelStyle}>Expiry Alert:</Typography>
                                    <Typography sx={valueStyle}>{rowData?.expiryAlert ? rowData?.expiryAlert : "N/A"}</Typography>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                    <Typography sx={labelStyle}>Validity (Days):</Typography>
                                    <Typography sx={valueStyle}>{rowData?.validityDays ? rowData?.validityDays : "N/A"}</Typography>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                    <Typography sx={labelStyle}>Renewal Date:</Typography>
                                    <Typography sx={valueStyle}>
                                        {rowData?.renewalDate ? moment.utc(rowData?.renewalDate).format("DD MMM YYYY") : "N/A"}
                                    </Typography>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                    <Typography sx={labelStyle}>Claim Period (Days):</Typography>
                                    <Typography sx={valueStyle}>{rowData?.claimPeriodDays ? rowData?.claimPeriodDays : "N/A"}</Typography>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                    <Typography sx={labelStyle}>Remarks / Conditions:</Typography>
                                    <Typography sx={valueStyle}>{rowData?.remarksOrConditions ? rowData?.remarksOrConditions : "N/A"}</Typography>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                    <Typography sx={labelStyle}>Last Updated:</Typography>
                                    <Typography sx={valueStyle}>
                                        {rowData?.lastUpdated ? moment.utc(rowData?.lastUpdated).format("DD MMM YYYY") : "N/A"}
                                    </Typography>
                                </Grid>

                            </Grid>
                        </CardContent>
                    </Card>
                </DialogContent>
            </Dialog>
        </>
    );
};

export default ViewPBG;